<template>
  <div id="popup-container">
    <v-toolbar dark color="primary">
      <v-toolbar-title>
        Add a new group
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn fab x-small class="close" @click="closePanel">
        <v-icon dark>fa-times</v-icon>
      </v-btn>
    </v-toolbar>
    <v-container>
      <v-row>
        <v-col md="12">
          <v-form>
            <v-text-field
              v-model="group.name"
              :error-messages="messages.name"
              label="Group Name"
              type="text"
              hint="Group name must be unique"
              filled
            >
              <template slot="append-outer">
                <v-tooltip left>
                 <template v-slot:activator="{on}">
                  <v-icon v-on="on">fa fa-question</v-icon>
                 </template>
                 <span>Group name must be unique</span>
                </v-tooltip>
              </template>
            </v-text-field>
            <v-textarea
              v-model="group.description"
              :error-messages="messages.description"
              label="Group Description"
              hint="Enter a description for this group"
              filled
            >
              <template slot="append-outer">
                <v-tooltip left>
                 <template v-slot:activator="{on}">
                  <v-icon v-on="on">fa fa-question</v-icon>
                 </template>
                 <span>Enter a description for this group</span>
                </v-tooltip>
              </template>
            </v-textarea>
          </v-form>
        </v-col>
      </v-row>
    </v-container>
    <v-footer absolute height="68">
      <v-flex px-4 py-4 text-right>
        <v-btn v-if="!loading" color="grey300" class="mr-4 cancel-button" @click="closePanel">Cancel</v-btn>
        <v-btn v-if="loading" color="primary" loading></v-btn>
        <v-btn v-else color="dark-blue" class="add-course-button" @click="addGroup">Save Changes</v-btn>
      </v-flex>
    </v-footer>
  </div>
</template>
<script>
import { EventBus } from "@/event-bus.js";
import groupAPI from "@/api/group.js";
export default {
  name: "AddGroup",
  props: {
    params: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      group: {},
      messages: {},
      loading: false,
      successMessage: "Group Successfully Added.",
      errorMessage:
        "Oops, something went wrong! Please check information is correct."
    };
  },
  methods: {
    closePanel() {
      this.$emit("closePanel", {});
    },
    addGroup() {
      this.loading = true;
      groupAPI
        .createGroup(this.group)
        .then(() => {
          this.closePanel();
          EventBus.$emit("GROUPS_UPDATED", this.params);
          this.$snotify.success(this.successMessage);
          this.loading = false;
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
        })
        .catch(err => {
          this.valid = false;
          this.messages = this.$gf.errorResponse(err);
          let errorMsg = err.response.data.message;
          if(errorMsg) {
            this.errorMessage = errorMsg;
          }
          this.$snotify.error(this.errorMessage);
          this.loading = false;
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
        });
    }
  }
};
</script>
